import { Redirect, useLocation } from 'react-router-dom';
import { z } from 'zod';
import { Box, Stack } from '@rossum/ui/material';
import { parse } from '../../lib/url';
import { LoginFailed } from './LoginFailed';
import { MetabaseAuthError } from './MetabaseAuthError';
import { MetabaseCollectionsError } from './MetabaseCollectionsError';
import { MetabaseReportError } from './MetabaseReportError';
import { NoPermission } from './NoPermission';
import { NotFound } from './NotFound';
import { TooManyRequests } from './TooManyRequests';

const reasonSchema = z.union([
  z.literal('login-failed'),
  z.literal('too-many-requests'),
  z.literal('not-found'),
  z.literal('no-permission'),
  z.literal('metabase-auth-error'),
  z.literal('metabase-collections-error'),
  z.literal('metabase-report-error'),
]);

const componentsMap = {
  'too-many-requests': TooManyRequests,
  'login-failed': LoginFailed,
  'not-found': NotFound,
  'no-permission': NoPermission,
  'metabase-auth-error': MetabaseAuthError,
  'metabase-collections-error': MetabaseCollectionsError,
  'metabase-report-error': MetabaseReportError,
};

const ErrorPage = () => {
  const location = useLocation();

  const { search } = location;
  const { reason } = parse(search);

  const parsed = reasonSchema.safeParse(reason);

  if (!parsed.success) {
    return <Redirect to="/" />;
  }

  const CustomReasonComponent = componentsMap[parsed.data];

  return (
    <Stack data-page-title={parsed.data}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          padding: 2,
          gap: 2,
        }}
      >
        <CustomReasonComponent />
      </Box>
    </Stack>
  );
};

export { ErrorPage };
